import { Html } from '@bbl-digital/snorre-v2'
import bp from 'shared/constants/breakpoints'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 1.5em;
  max-height: 70vh;
  overflow: hidden;
  overflow-y: auto;

  button {
    justify-self: center;
    padding: 0 3em;
  }

  h3 {
    text-align: center;
  }

  @media screen and (max-width: ${bp.small}) {
    grid-row-gap: 1em;
  }
`

export const Div = styled.div`
  padding: 0 2em;
  justify-self: center;

  svg {
    margin-bottom: -4px;
  }

  @media screen and (max-width: ${bp.small}) {
    padding: 0 0.5em;
  }
`

export const StyledHtml = styled(Html)`
  line-height: 1.4;
`
